<template>
  <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }">
    <a-row :gutter="24">
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_associated_plan')">
          <a-radio-group
            v-decorator="[
              'isPlan',
              {
                initialValue: 0,
                rules: [{ required: true, message: $t('page_material_warehousing_p_select') }]
              }
            ]"
            @change="changePlan"
          >
            <a-radio :value="1">
              {{ $t('yes') }}
            </a-radio>
            <a-radio :value="0">
              {{ $t('no') }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_order_code')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="[
              'planCode',
              {
                rules: [
                  {
                    required: comformDefa.isPlan,
                    message: $t('page_material_warehousing_p_select')
                  }
                ]
              }
            ]"
            :disabled="!comformDefa.isPlan"
            showSearch
            :placeholder="$t('please_select') + $t('page_material_warehousing_order_code')"
            @change="handleChangePlan"
          >
            <template v-for="(item, index) in comformDefa.planList">
              <a-select-option :key="index" :value="item.code">
                {{ item.code }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12" v-show="comformDefa.isPlan">
        <a-form-item :label="$t('page_material_warehouse_plan_doc_no')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="['stockOutPlanId']"
            showSearch
            :placeholder="$t('please_select') + $t('page_material_warehouse_plan_doc_no')"
            @change="handleChangeDelivery"
          >
            <template v-for="(item, index) in deliveryList">
              <a-select-option :key="index" :value="item.id">
                {{ item.code }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_system_coding_rules')">
          <a-select
            style="width: 100%"
            show-search
            optionFilterProp="children"
            v-decorator="['codeRuleId']"
            :placeholder="$t('please_select') + $t('page_system_coding_rules')"
            :allowClear="true"
            @change="selectCodeRule"
          >
            <a-select-option :value="item.value" v-for="(item, index) in codeList" :key="index">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_code')">
          <div>
            <a-input
              style="width: 100%"
              :disabled="codeRule != undefined"
              :placeholder="$t('common_please_input') + $t('page_material_warehousing_code')"
              v-decorator="['orderCode']"
            />
          </div>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_name')">
          <a-input
            style="width: 100%"
            v-decorator="['orderName', { max: 48 }]"
            :placeholder="$t('common_please_input') + $t('page_material_warehousing_name')"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_delivery_no')">
          {{ $t('page_material_warehousing_automatic') }}
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_feeding_ren')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="['deliveryUser']"
            @change="handleSelectChange"
            :placeholder="$t('please_select') + $t('page_material_warehousing_feeding_ren')"
          >
            <a-select-option v-for="s in staff" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_receipt_code')">
          {{ $t('page_material_warehousing_automatic') }}
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_receipt_dept')">
          <a-tree-select
            v-decorator="['receivingDept']"
            :treeData="depts"
            tree-default-expand-all
            show-search
            tree-node-filter-prop="title"
            @change="handleReceivingDeptName"
            :placeholder="$t('please_select') + $t('page_material_warehousing_receipt_dept')"
          >
          </a-tree-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_receipt_ren')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="[
              'receivingUser',
              {
                rules: [{ required: true, message: $t('page_material_warehousing_p_select') }]
              }
            ]"
            :placeholder="$t('please_select') + $t('page_material_warehousing_receipt_ren')"
            @change="handleReceivingUser"
          >
            <a-select-option v-for="s in staff" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('supplier')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="['supplierId']"
            @change="handleSupplierName"
            :placeholder="$t('please_select') + $t('supplier')"
          >
            <a-select-option v-for="s in supplierList" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_ware_out_code')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="[
              'outOrderCode',
              {
                rules: [
                  {
                    required: stockOutPlanCode != '',
                    message: $t('page_material_warehousing_p_select')
                  }
                ]
              }
            ]"
            :placeholder="$t('please_select') + $t('page_material_ware_out_code')"
            allowClear
            @change="(value) => handleChangeOutOrder(value)"
          >
            <a-select-option v-for="s in stockOutOrderList" :key="s.orderCode" :value="s.orderCode">
              {{ s.orderCode }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>
<script>
import { ProductionPlanServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import {
  StockOutOrderServiceProxy,
  StockOutPlanServiceProxy
} from '@/service-proxies/app-v2/wms.service-proxies'

const sopsp = new StockOutPlanServiceProxy()
const soosp = new StockOutOrderServiceProxy()
const ppsp = new ProductionPlanServiceProxy()
import form from './form.js'
export default {
  mixins: [form],
  data() {
    return {
      form: this.$form.createForm(this),
      codeList: [],
      supplierList: [],
      stockOutOrderList: [],
      deliveryUserName: '',
      receivingUserName: '',
      supplierName: '',
      planListF: [],
      deliveryList: [],
      stockOutPlanCode: ''
    }
  },
  props: {
    staff: {
      type: Array,
      default: () => []
    },
    depts: {
      type: Array,
      default: () => []
    },
    inTypeCode: {
      type: String,
      default: ''
    }
  },
  methods: {
    getMaterialPlanList() {
      ppsp.productMaterials().then((res) => {
        this.comformDefa.planList = this.addCode(res)
      })
    },
    save(value, callback) {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.comformDefa.isPlan) {
            const plan = this.comformDefa.planList.find(
              (res) => res.code === this.comformDefa.selectPlan
            )
            values.planCode = this.comformDefa.selectPlan
            values.planId = plan ? plan.id : ''
            values.stockOutPlanCode = this.stockOutPlanCode
          }
          console.log(values)
          const data = { ...values, ...value }
          callback(data)
        } else {
          callback(false)
        }
      })
    },
    // 关联计划
    changePlan(value) {
      this.changeReast()
      this.comformDefa.selectPlan = ''
      if (value.target.value === 1) {
        this.comformDefa.isPlan = true
        this.stockOutOrderList = []
        this.getMaterialPlanList()
      } else {
        this.form.setFieldsValue({
          planCode: ''
        })
        this.planListF = []
        this.getStockOutOrder()
        this.comformDefa.isPlan = false
      }
      this.reastForm()
      this.$emit('changDefa', this.comformDefa)
    },
    reastForm() {
      this.form.setFieldsValue({
        outOrderCode: undefined,
        stockOutPlanId: ''
      })
      this.stockOutPlanCode = ''
      this.deliveryList = []
      this.comformDefa.hasStockOutPlan = false
    },
    handleChangePlan(value) {
      // this.changeReast()
      this.getMaterialPlanList()
      this.comformDefa.selectPlan = value
      if (this.comformDefa.selectPlan && this.inTypeCode) {
        this.getStockPlanOrder()
        this.getDeliveryList(this.comformDefa.selectPlan)
      } else {
        this.getStockOutOrder()
      }
      this.reastForm()
      this.$emit('changDefa', this.comformDefa)
    },
    getStockPlanOrder() {
      this.stockOutOrderList = []
      const plan = this.comformDefa.planList.find((res) => res.code === this.comformDefa.selectPlan)
      if (plan) {
        soosp.getOutOrderByPlanId(plan.id).then((res) => {
          this.stockOutOrderList = res
        })
      }
    },
    async getDeliveryList(value) {
      const plan = this.comformDefa.planList.find((res) => res.code === value)
      this.deliveryList = []
      if (plan) {
        const res = await sopsp.listStockOutPlanByPlanId(plan.id)
        this.deliveryList = res
      }
    },
    async handleChangeDelivery(value) {
      this.form.setFieldsValue({
        outOrderCode: undefined
      })
      const stock = this.deliveryList.find((res) => res.id === value)
      this.stockOutPlanCode = stock.code
      this.comformDefa.hasStockOutPlan = true
      this.$emit('changDefa', this.comformDefa)
      const res = await soosp.getOutOrderByStockOutPlanId(value)
      if (res) {
        this.stockOutOrderList = res
      } else {
        this.stockOutOrderList = []
      }
    }
  }
}
</script>
<style scoped></style>
